import React from 'react';

import {AutoComplete, Input} from 'antd';
import { head } from 'lodash';

class WidgetInputSelect extends React.Component {

    constructor( props )
    {
        super(props);

        this.state = {
            options:[],
        }
    }

    buildData = () => {

    }

    searchData = ( value ) => {

        const { allData=[] } = this.state;

        let options = [];

        for(let item of allData)
        {
            if( item.name.indexOf(value)!=-1 )
            {
                let label = item.name.replace(value, '<span class="sf-found-word">' + value + '</span>');

                options.push({
                    ...item, 
                    value:item.value,
                    label:(
                        <div className='sf-input-select-item'>
                            <div dangerouslySetInnerHTML={{ __html: label }} />
                        </div>
                    )
                })
            }
            
        }

        this.setState({options:options});
    }

    onSelect = ( value ) => {

        const { allData=[] } = this.state;

        let ret = {};

        for( let item of allData)
        {
            if( item.value===value )
            {
                ret = {...item};
                break;
            }
        }

        this.setState({value:ret.name});
        
        if( this.props.notify )
        {
            this.props.notify(value, ret);
        }
    }

    componentWillReceiveProps( nextProps )
    {
        const { data } = nextProps;

        this.setState({allData:[...data]});
    }

    render()
    {
        const { placeholder } = this.props;

        const {  options=[], value } = this.state;

        return (
            <AutoComplete
                popupMatchSelectWidth={252}
                style={{ width: 260, height:30 }}
                options={options}
                onSelect={this.onSelect}
                onSearch={this.searchData}
                value={value}
                >
                <Input.Search size="large" placeholder={placeholder}/>
            </AutoComplete>
        )
    }
}
export default WidgetInputSelect;